import React, { useEffect, useRef, useState } from 'react';
import { LuCheck, LuChevronDown } from 'react-icons/lu';
import { AGENT_COLOR } from './agentCatalog';

const DONE = '#2F9E6E';

const AgentReadiness = ({ items, theme }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const done = items.filter((item) => item.done).length;
  const raised = theme.cardBg === '#FFFFFF' ? '#F3F4F6' : '#232B36';

  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '10px',
          padding: '6px 10px',
          borderRadius: '8px',
          border: `1px solid ${theme.border}`,
          backgroundColor: theme.cardBg,
          color: theme.textPrimary,
          fontSize: '12px',
          fontWeight: 600,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        {done === items.length ? 'Listo para publicar' : 'Por terminar'}
        <span style={{ display: 'flex', gap: '3px' }}>
          {items.map((item) => (
            <span key={item.key} style={{ width: '14px', height: '5px', borderRadius: '2px', backgroundColor: item.done ? DONE : theme.border }} />
          ))}
        </span>
        <span style={{ color: theme.textSecondary }}>
          {done} de {items.length}
        </span>
        <LuChevronDown style={{ fontSize: '14px', color: theme.textSecondary }} />
      </button>
      {open && (
        <div
          role="menu"
          style={{
            position: 'absolute',
            top: '40px',
            right: 0,
            zIndex: 1100,
            width: '300px',
            padding: '6px',
            borderRadius: '10px',
            backgroundColor: theme.cardBg,
            border: `1px solid ${theme.border}`,
            boxShadow: '0 12px 28px rgba(0, 0, 0, 0.3)',
          }}
        >
          {items.map((item) => (
            <button
              key={item.key}
              type="button"
              role="menuitem"
              disabled={item.done && !item.onClick}
              onClick={() => {
                setOpen(false);
                item.onClick?.();
              }}
              onMouseEnter={(event) => (event.currentTarget.style.backgroundColor = raised)}
              onMouseLeave={(event) => (event.currentTarget.style.backgroundColor = 'transparent')}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                width: '100%',
                textAlign: 'left',
                padding: '10px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: 'transparent',
                color: theme.textPrimary,
                cursor: item.onClick ? 'pointer' : 'default',
              }}
            >
              <span
                style={{
                  width: '18px',
                  height: '18px',
                  minWidth: '18px',
                  borderRadius: '50%',
                  marginTop: '1px',
                  boxSizing: 'border-box',
                  backgroundColor: item.done ? DONE : 'transparent',
                  border: item.done ? 'none' : `2px solid ${theme.textSecondary}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {item.done && <LuCheck style={{ fontSize: '11px', color: '#FFFFFF' }} />}
              </span>
              <span style={{ display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0 }}>
                <span style={{ fontSize: '13px', fontWeight: 600 }}>{item.label}</span>
                <span style={{ fontSize: '12px', color: theme.textSecondary }}>
                  {item.detail}
                  {!item.done && item.onClick && <span style={{ color: AGENT_COLOR, fontWeight: 600 }}> · Resolver</span>}
                </span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AgentReadiness;
